<div class="input-color-field">
    <mat-form-field appearance="outline">
        <mat-label>{{ config.label }}</mat-label>
        <div class="color-input-container">
            <input matInput
                [formControlName]="config.name"
                type="color"
                [attr.placeholder]="config.placeholder"
                (change)="onColorChange($event)"
                [disabled]="config.disabled || typeCes === typeCesEnum.SHOW">
            <div class="color-preview"
                [style.background-color]="group.get(config.name)?.value || 'transparent'"
                [style.border]="!group.get(config.name)?.value ? '1px dashed #ccc' : 'none'">
            </div>
        </div>
        <mat-error *ngIf="group.get(config.name)?.hasError('required')">
            {{ config.label }} é obrigatório.
        </mat-error>
    </mat-form-field>
</div>